// extracted by mini-css-extract-plugin
export default {"wrapper":"LB-z","viewport":"MB-z","container":"NB-z","slide":"OB-z"};